import './styles/App.css';
import './styles/index.css';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation
} from "react-router-dom";
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { UnreadProvider } from './contexts/UnreadContext';
import { Spinner } from './components/ui';
import Header from './components/Header';
import Login from './pages/Login';
import Register from './pages/Register';
import Welcome from './pages/Welcome';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import Store from './pages/Store';
import NewItem from './pages/NewItem';
import EditItem from './pages/EditItem';
import User from './pages/User';
import Analytics from './pages/Analytics';
import Item from './pages/Item';
import Messages from './pages/Messages';
import Favourites from './pages/Favourites';
import NotFound from './pages/NotFound';

const HIDE_HEADER_PATHS = ['/welcome', '/login', '/register'];

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[var(--color-bg)] flex flex-col items-center justify-center gap-4">
        <Spinner className="h-12 w-12" alt="" />
        <div className="text-[var(--color-muted)]">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children ? children : <Outlet />;
};

const AppLayout = () => {
  const location = useLocation();
  const hideHeader = HIDE_HEADER_PATHS.includes(location.pathname);

  return (
    <>
      {!hideHeader && <Header />}
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Navigate to="/store" replace />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/store" element={<Store />} />
        <Route path="/user/:username" element={<User />} />
        
        {/* Item routes */}
        <Route path="/store/item" element={<Navigate to="/store" replace />} />
        <Route path="/store/item/:id" element={<Item />} />
        
        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/profile/messages" element={<Messages />} />
          <Route path="/profile/messages/:id" element={<Messages />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/profile/edit" element={<EditProfile />} />
          <Route path="/profile/newitem" element={<NewItem />} />
          <Route path="/profile/edititem/:id" element={<EditItem />} />
          <Route path="/profile/analytics" element={<Analytics />} />
          <Route path="/profile/favourites" element={<Favourites />} />
        </Route>
        
        {/* 404 catch-all */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <div className="App w-full h-full">
      <AuthProvider>
        <UnreadProvider>
          <BrowserRouter>
            <AppLayout />
          </BrowserRouter>
        </UnreadProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
